var exports = {
  "kL": "HandoffApprovalFlow.module__container___ejlsVU",
  "DD": "HandoffApprovalFlow.module__title___ejlsVU",
  "h_": "HandoffApprovalFlow.module__description___ejlsVU",
  "BB": "HandoffApprovalFlow.module__codeInputSection___ejlsVU",
  "IX": "HandoffApprovalFlow.module__codeInput___ejlsVU",
  "aY": "HandoffApprovalFlow.module__code___ejlsVU",
  "YG": "HandoffApprovalFlow.module__matchCheck___ejlsVU",
  "Gp": "HandoffApprovalFlow.module__accountLine___ejlsVU",
  "Hh": "HandoffApprovalFlow.module__wrongAccount___ejlsVU",
  "uX": "HandoffApprovalFlow.module__textButton___ejlsVU",
  "N8": "HandoffApprovalFlow.module__deviceCard___ejlsVU",
  "fz": "HandoffApprovalFlow.module__deviceRow___ejlsVU",
  "hV": "HandoffApprovalFlow.module__deviceLabel___ejlsVU",
  "sv": "HandoffApprovalFlow.module__deviceValue___ejlsVU",
  "v0": "HandoffApprovalFlow.module__buttonRow___ejlsVU",
  "u1": "HandoffApprovalFlow.module__spinner___ejlsVU",
  "z3": "HandoffApprovalFlow.module__error___ejlsVU",
  "FU": "HandoffApprovalFlow.module__successIcon___ejlsVU",
  "bS": "HandoffApprovalFlow.module__deniedIcon___ejlsVU",
};

module.exports = exports;
